import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';

import Dashboard from '@/views/Dashboard';

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login'),
    meta: {
      public: true,
    },
  },
  {
    path: '/login-pro',
    name: 'login-pro',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginPro'),
    meta: {
      public: true,
    },
  },
  {
    path: '/login-user',
    name: 'login-user',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginUser'),
    meta: {
      public: true,
    },
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import(/* webpackChunkName: "signup" */ '../views/SignUp'),
    meta: {
      public: true,
    },
  },
  {
    path: '/signup-success',
    name: 'signup-success',
    component: () => import(/* webpackChunkName: "signupsuccess" */ '../views/SignUpSuccess'),
    meta: {
      public: true,
    },
  },
  {
    path: '/verify',
    name: 'verify',
    component: () => import(/* webpackChunkName: "verify" */ '../views/Verify'),
    meta: {
      public: true,
    },
  },
  {
    path: '/finish-setup',
    name: 'finish-setup',
    component: () => import(/* webpackChunkName: "finish-setup" */ '../views/FinishSetup'),
  },
  {
    path: '/finish-setup-avatar',
    name: 'finish-setup-avatar',
    component: () => import(/* webpackChunkName: "finish-setup" */ '../views/FinishSetupAvatar'),
  },
  {
    path: '/finish-setup-complete',
    name: 'finish-setup-complete',
    component: () => import(/* webpackChunkName: "finish-setup" */ '../views/FinshSetupComplete'),
  },
  {
    path: '/password-reset',
    name: 'reset-password',
    component: () =>
      import(/* webpackChunkName: "passwordresetrequest" */ '../views/PasswordResetRequest'),
    meta: {
      public: true,
    },
  },
  {
    path: '/set-password',
    name: 'set-password',
    component: () => import(/* webpackChunkName: "passwordreset" */ '../views/PasswordReset'),
    meta: {
      public: true,
    },
  },
  {
    path: '/legal/privacy-policy',
    name: 'privacy-policy',
    component: () => import(/* webpackChunkName: "privacy-policy" */ '../views/PrivacyPolicy'),
    meta: {
      public: true,
    },
  },
  {
    path: '/legal/terms-of-service',
    name: 'terms-of-service',
    component: () => import(/* webpackChunkName: "terms-of-service" */ '../views/TermsOfService'),
    meta: {
      public: true,
    },
  },
  {
    path: '/legal/dmca',
    name: 'dmca',
    component: () => import(/* webpackChunkName: "dmca" */ '../views/DMCA'),
    meta: {
      public: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  // const redirect = document.referrer && document.referrer.includes('casago.com') ? document.referrer : undefined;

  if (to.matched.length === 0) {
    return next('/');
  }

  const isPublic = to.matched.some((record) => record.meta.public);

  if (isPublic) return next();

  // make sure the auth cookie still exists
  return store.dispatch('auth/validate').then((user) => {
    user ? next() : next({ path: '/login', query: { redirect: to.query.redirect || to.path } });
  });
});

export default router;
